export default __webpack_public_path__ + "static/media/advanced-bookkeeping.077986c6.png";